import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organization_id: window.localStorage.getItem("organization_id") || "",
  is_org_integrated_to_zoho:
    window.localStorage.getItem("is_org_integrated_to_zoho") || false,
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    set_OrganizationID: (state, action) => {
      state.organization_id = action.payload;
    },

    set_OrgIntegratedToZoho: (state, action) => {
      console.log(action.payload);

      state.is_org_integrated_to_zoho = action.payload;
    },
  },
});

export const { set_OrganizationID, set_OrgIntegratedToZoho } =
  configSlice.actions;

export default configSlice.reducer;
